import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import index from '@/views/index/index' 
import mIndex from '@/views/m/index/index'
let router = new Router({
  mode: 'history', // 或者 'hash'
  routes: [
    {path: '/',name: 'index',component: index, meta:{title:"天台本地社交平台 - 天台生活"}},
    {path: '/about',name: 'about',component:() => import('@/views/about/index'), meta:{title:"天台本地社交平台 - 天台生活"}},

    {path: '/m',name: 'mIndex',component: mIndex, meta:{isMobile:true,title:"天台本地社交平台 - 天台生活"}},
    {path: '/m/about',name: 'mAbout',component:() => import('@/views/m/about/index'), meta:{isMobile:true,title:"天台本地社交平台 - 天台生活"}},

    //app使用
    {path:"/privacyPolicy",name:"privacyPolicy",component:() => import('@/views/app/privacyPolicy'),meta:{isMobile:true,title:"隐私协议"}},             //隐私协议
    {path:"/thirdPartySdk",name:"thirdPartySdk",component:() => import('@/views/app/thirdPartySdk'),meta:{isMobile:true,title:"第三方sdk列表"}},         //第三方sdk列表
    {path:"/userAgreement",name:"userAgreement",component:() => import('@/views/app/userAgreement'),meta:{isMobile:true,title:"用户协议"}},             //用户协议
    {path:"/article",name:"article",component:() => import('@/views/app/article/index'),meta:{isMobile:true,title:"文章详情-天台生活",dynamic:true}},    //帖子详情页
    {path:"/openApp",name:"openApp",component:() => import('@/views/app/openApp'),meta:{isMobile:true,title:"天台生活",dynamic:true}},                  //打开app 
  ]
})

function setRem() {
    const designWidth = 750
    const baseFont = 100
    let width = window.innerWidth
    if (width > designWidth) width = designWidth
    document.documentElement.style.fontSize = width / designWidth * baseFont + 'px'
}

router.beforeEach((to, from, next) => {
    // 假设你在路由 meta 里标记移动端页面
    if (to.meta.isMobile) {
        setRem()
        window.addEventListener('resize', setRem)
        window.addEventListener('pageshow', e => { e.persisted && setRem() })
        document.body.classList.add('mobile-page')
    } else {
        document.body.classList.remove('mobile-page')
        document.documentElement.style.fontSize = '' // 取消 rem
        window.removeEventListener('resize', setRem)
        window.removeEventListener('pageshow', setRem)
    }
    next()
})

router.afterEach((to)=>{
    if(to.meta.dynamic){        //动态标题
        document.title = '加载中...'
    }else if(to.meta.title){    //固定标题
        document.title = to.meta.title
    }else{                      //默认标题
         document.title = '天台生活'
    }
})



export default router